import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

const multiple = nota.global.multiple;

const WrapperList = styled.div`
  border: ${(props) => (props.simple ? `1px solid ${nota.color.neutral.NeuFive}` : `1px solid ${nota.color.main.default}`)};
  border-top: ${(props) => (props.simple ? `1px solid ${nota.color.neutral.NeuFive}` : `3px solid ${nota.color.main.default}`)};
  box-shadow: ${(props) => (props.simple ? `none` : `0px 4px 4px rgba(0, 0, 0, 0.25)`)};
  margin: ${(props) => (props.simple ? `0` : `${multiple + "px"}`)};
  margin-bottom: ${(props) => (props.simple ? `${multiple / 2 + "px"}` : `${multiple + "px"}`)};
  padding: ${multiple + "px"}; /* 8px */
  position: relative;
  background-color: ${(props) => (props.background ? nota.color.secondary.secFour : nota.color.neutral.white)};
  width: 100%;
`;

WrapperList.defaultProps = {
  background: false,
  simple: false,
};

export default WrapperList;

// --- // Documentation // --- //
/*
import WrapperList from './../Nano/WrapperList.js';

<WrapperList />
<WrapperList background />
<WrapperList simple />
*/
